import CoreButtons from '../CoreBlocks/CoreButtons';
import CoreCover from '../CoreBlocks/CoreCover';
import CoreGroup from '../CoreBlocks/CoreGroup';
import CoreHeading from '../CoreBlocks/CoreHeading';
import CoreImage from '../CoreBlocks/CoreImage';
import CoreList from '../CoreBlocks/CoreList';
import CoreListItem from '../CoreBlocks/CoreListItem';
import CoreMediaText from '../CoreBlocks/CoreMediaText';
import CoreParagraph from '../CoreBlocks/CoreParagraph';
import CoreQuote from '../CoreBlocks/CoreQuote';
import CoreTable from '../CoreBlocks/CoreTable';
import Fields from './index';

import { Field as FieldBlock, CoreBlock } from '../../types';

export type Block = FieldBlock | CoreBlock;

export const blockMap: Record<
  string,
  React.ComponentType<{
    block: Block;
    renderBlocks: (block: Block, i: number) => React.ReactNode;
  }>
> = {
  'core/buttons': CoreButtons,
  'core/cover': CoreCover, // Currently removed from Gutenberg
  'core/group': CoreGroup,
  'core/heading': CoreHeading,
  'core/image': CoreImage,
  'core/list': CoreList,
  'core/list-item': CoreListItem,
  'core/media-text': CoreMediaText,
  'core/paragraph': CoreParagraph,
  'core/quote': CoreQuote,
  'core/table': CoreTable,
};

export const FallbackBlock = ({ block }) => (
  <pre style={{ background: '#eee', padding: '1rem' }}>
    Unknown block: {block.__name}
    <br />
    {JSON.stringify(block, null, 2)}
  </pre>
);

export const BlockRenderer = ({ blocks }) => {
  const renderBlocks = (block, i) => {
    if (block.__name?.startsWith('acf/') || block.__name?.startsWith('mhy/')) {
      return (
        <Fields
          key={`${block.__name}-${i}`}
          renderBlocks={renderBlocks}
          fields={[block]}
        />
      );
    }

    const BlockComponent = blockMap[block.__name] || FallbackBlock;
    if (!BlockComponent) {
      return null;
    }

    return (
      <BlockComponent
        key={`${block.__name}-${i}`}
        block={block}
        renderBlocks={renderBlocks}
      />
    );
  };

  return <>{blocks.map(renderBlocks)}</>;
};
